export const MODULE_NAME = 'POPUP_LIST_MODULE_NAME';

export const ACTION_TYPE = {
  REQUEST_PENDING: `${MODULE_NAME}.REQUEST_PENDING`,
};

export const API = {
  TYPE: 'GET',
  URL: `/popup/user-list`,
};

export interface POPUP_ITEM_DATA_RAW_INTER {
  id: string;
  body: string;
  linkUrl?: string;
  imgUrl?: string;
}

export interface POPUP_ITEM_LIST_DATA_RAW_INTER {
  list: POPUP_ITEM_DATA_RAW_INTER[];
}

export interface POPUP_ITEM_DATA_INTER extends POPUP_ITEM_DATA_RAW_INTER {}

export interface POPUP_ITEM_LIST_DATA_INTER {
  list: POPUP_ITEM_DATA_INTER[];
  isEmpty: boolean;
}

export interface DATA_INTER extends POPUP_ITEM_LIST_DATA_INTER {}

export interface ACTION_RESPONSE_INTER extends POPUP_ITEM_LIST_DATA_RAW_INTER {}
